<template>
<v-main>
  <v-layout class="ma-2" justify-center>
    <v-card class="px-4 rounded-xl" width="1200">
      <v-card-title>
        Adicionar Exames ao técnico
      </v-card-title>
      <v-divider class="mb-4" />

      <v-text-field v-model="nomeMedico" disabled :type="'text'" name="input-10-1" label="Nome do técnico" counter @click:append="show1 = !show1" />

      <v-progress-circular v-show="mostrarLoading" indeterminate :size="69" />

      <v-form v-if="mostrarListaServicos" ref="form1" v-model="valid">
        <v-flex xs12 sm12>
          <v-autocomplete v-model="servicoSelecionado" return-object no-data-text="Nenhum serviço disponível" :items="servicosMedico" item-text="nomeEspecialidade" label="Serviço" :rules="[(v) => !!v || 'Você deve escolher um serviço para continuar']" hint="Escolha um serviço" persistent-hint />
        </v-flex>

        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Erro ao editar nome !!
        </v-alert>

        <v-alert :value="erroId" color="error" icon="warning" outlined>
          Escolha um medico na lista de médicos !!
        </v-alert>
        <v-alert :value="erroServicosIguais" color="error" icon="warning" outlined>
          Serviços já cadastrados para este Médico
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso ao cadastrar exames serviços do médico !!
        </v-alert>
        <v-card-actions>
          <v-spacer />
          <v-btn rounded dark :class="{ red: !valid, green: valid }" @click="retornarExames">
            Selecionar
          </v-btn>
          <v-btn rounded outlined to="/listaTecnicosUnidade" @click="">
            <v-icon left>
              keyboard_backspace
            </v-icon>
            voltar
          </v-btn>
        </v-card-actions>

      </v-form>
       <v-form v-show="mostrarListaExames" v-model="valid2" ref="form2">

        <v-autocomplete v-model="listaExamesDoMedico" no-data-text="Nenhum serviço disponível" :items="listaExamesRetornados" return-object item-value="idExame" item-text="nomeExame" :rules="[(v) => v && v.length > 0 || 'Escolha um ou mais exames para cadastrar']" label="Exames" hint="Exames do médico" chips persistent-hint multiple>
          <template v-slot:prepend-item>
            <v-list-item ripple @click="toggle">
              <v-list-item-action>
                <v-icon :color="listaExamesDoMedico.length > 0 ? 'indigo darken-4' : ''"> {{icon}} </v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{msgSelecionarTudo}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
          </template>

        </v-autocomplete>

        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Voce deve concordar para cadastrar!']" required></v-checkbox>
        <v-alert :value="erroEditar" color="error" icon="warning" outlined>
          Erro ao editar nome !!
        </v-alert>

        <v-alert :value="erroId" color="error" icon="warning" outlined>
          Escolha um medico na lista de médicos !!
        </v-alert>
        <v-alert :value="erroServicosIguais" color="error" icon="warning" outlined>
          Serviços já cadastrados para este Médico
        </v-alert>

        <v-alert :value="sucessoEditar" color="success" icon="check_circle" outlined>
          Sucesso ao alterar Exames do médico !!
        </v-alert>
        <v-card-actions>
          <v-spacer />
        <v-btn rounded dark @click="cadastrarExameMedico" :class="{ red: !valid2, green: valid2 }">Cadastrar</v-btn>
        <v-btn rounded outlined @click="voltar">
          <v-icon left>keyboard_backspace</v-icon>
          voltar
        </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-layout>
</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'
// import EventBus from '../../../main';

export default {
  name: 'EditarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      erroEditar: false,
      idMedico: '',
      VariavelAlterou: true,
      erroId: false,
      nomeMedico: '',
      codigoServicoSelecionado: '',
      MensagemSelecionarTodos: '',
      mostrarListaExames: false,
      mostrarListaServicos: true,
      mostrarLoading: false,
      erroServicosIguais: false,
      servicosEscolhidos: '',
      servicosMedico: [],
      servicosMedicoInicial: [],
      examesEscolhidos: [],
      servicoSelecionado: null,
      listaExamesRetornados: [],
      listaDeExamesServico: [],
      listaExamesDoMedico: [],
      listaExamesDoMedicoInicial: [],
      sucessoEditar: false,
      exameInicial: [],
      isEditing: true,
      listaServicos: [],
      listaServicosUnidade: [],
      nomeEspecialidade: '',
      codigoServicoSelecionado: '',
      valid: true,
      valid2: true,
      checkbox: false,
      nomeRules: [
        (v) => v && v.length > 5 || 'nome deve ter mais de 5 caracteres'
      ],
      items: [{
        nomeEspecialidade: 'Cardiologia',
        idServico: 1,
        quantVagas: 1,
        idLocal: 1
      },
      {
        nomeEspecialidade: 'Urologia',
        idServico: 3,
        quantVagas: 2,
        idLocal: 2
      },
      {
        nomeEspecialidade: 'Cirugia',
        idServico: 2,
        quantVagas: 10,
        idLocal: 3
      },
      {
        nomeEspecialidade: 'Ultrasom',
        idServico: 4,
        quantVagas: 10,
        idLocal: 4
      },
      {
        nomeEspecialidade: 'Cirugia 3',
        idServico: 5,
        quantVagas: 11,
        idLocal: 5
      },
      {
        nomeEspecialidade: 'Cirugia 4',
        idServico: 6,
        quantVagas: 11,
        idLocal: 6
      }
      ]
    }
  },

  computed: {

    escolheuTodosExames () {
      return this.listaExamesDoMedico.length === this.listaExamesRetornados.length
    },

    escolheuAlgunsExames () {
      return this.listaExamesDoMedico.length > 0 && !this.escolheuTodosExames
    },

    msgSelecionarTudo () {
      if (this.escolheuTodosExames) return 'Remover todos'
      if (this.escolheuAlgunsExames) return 'Selecionar todos'
      return 'Selecionar todos'
    },

    icon () {
      if (this.escolheuTodosExames) return 'remove'
      if (this.escolheuAlgunsExames) return 'add'
      return 'add'
    }
  },
  mounted () {
    console.log('em mounted cadst. tecn servic')
    console.log(this.$route.params.item)
    if (!this.$route.params.item) {
      this.$router.push('/listaTecnicosUnidade')
      return
    }

    this.user = this.$store.getters.usuario
    this.idMedico = this.$route.params.item.idMedico,
    this.nomeMedico = this.$route.params.item.nome
    // this.servicosEscolhidos = this.$route.params.item.servicos,
    this.erroEditar = false,
    console.log(this.idMedico)
    this.retornarServicosUnidade()
    this.retornarServicosMedico()
    this.sucessoEditar = false
  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
    console.log('created...')
  },

  methods: {

    voltar () {
      this.mostrarListaServicos = true
      this.mostrarListaExames = false
      this.listaExamesRetornados = []
      this.$refs.form2.reset()
      this.listaExamesDoMedico = []
    },

    toggle () {
      this.$nextTick(() => {
        if (this.escolheuTodosExames) {
          this.listaExamesDoMedico = []
        } else {
          this.listaExamesDoMedico = this.listaExamesRetornados.slice()
        }
      })
    },

    retornarExames () {
      if (this.$refs.form1.validate()) {
        this.mostrarLoading = true
        this.mostrarListaServicos = false

        console.log('em retornar exames unidade...')
        administradorUnidadeService.administradorUnidade
          .retornarExames(this.servicoSelecionado.idExameEspecialidade)
          .then(rsp => {
            console.log('rsp oi:', rsp.data)
            this.mostrarLoading = false
            this.mostrarListaExames = true
            this.listaExamesRetornados = rsp.data
            this.retornarExamesMedico()
            // console.log(this.listaServicosUnidade)
          })
          .catch(err => {
            this.mostrarLoading = false
            this.mostrarListaServicos = true
            // handle your error here
            console.log(err)
          })
      }
    },

    retornarServicosUnidade () {
      console.log('em retornar servico unidade...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosUnidade(this.user.idUnidade)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.listaServicosUnidade = rsp.data
          console.log(this.listaServicosUnidade)
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarServicosMedico () {
      console.log('em retornar servicos medicos...')
      administradorUnidadeService.administradorUnidade
        .retornarServicosMedico(this.idMedico)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.servicosMedico = rsp.data
          this.servicosMedicoInicial = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarExamesMedico () {
      console.log('em retornar exames medico...')
      administradorUnidadeService.administradorUnidade
        .retornarExamesMedico(this.servicoSelecionado.idServico, this.idMedico)
        .then(rsp => {
          console.log('rsp oi:', rsp.data)
          this.listaExamesDoMedico = rsp.data
          this.listaExamesDoMedicoInicial = rsp.data
        })
        .catch(err => {
          this.mostrarLoading = false
          this.mostrarListaServicos = true
          // handle your error here
          console.log(err)
        })
    },

    cadastrarExameMedico () {
      if (this.$refs.form2.validate()) {
        console.log('entrou no form..')
        let examesAux = []
        let examesSemNull = []
        this.erroExamesIguais = false

        if (this.listaExamesDoMedicoInicial.length > 0 && this.listaExamesDoMedico.length == 0) {
          console.log('primeiro if')
          for (let index = 0; index < this.listaExamesDoMedicoInicial.length; index++) {
            const element = this.listaExamesDoMedicoInicial[index]
            examesAux[index] = {
              idExame: element.idExame,
              status: 0
            }
          }
          console.log(examesAux)
          // return
        } else if (this.listaExamesDoMedicoInicial.length == 0 && this.listaExamesDoMedico.length > 0) {
          console.log('segundo if')
          for (let index = 0; index < this.listaExamesDoMedico.length; index++) {
            const element = this.listaExamesDoMedico[index]
            examesAux[index] = {
              idExame: element.idExame,
              status: 1
            }
          }
          console.log(examesAux)
          // return
        } else {
          let exameInicial = this.listaExamesDoMedicoInicial
          // modifica o array
          for (let index = 0; index < this.listaExamesDoMedico.length; index++) {
            const element = this.listaExamesDoMedico[index]
            examesAux[index] = {
              idExame: element.idExame,
              status: null
            }
          }

          console.log('aquiiiiiii', examesAux)
          // return ;

          examesAux.forEach(function (elementEscolhido, indexAux) {
            let estava = false
            let index = 0
            for (let index = 0; index < exameInicial.length; index++) {
              const element = exameInicial[index]
              if (element.idExame == elementEscolhido.idExame) {
                estava = true
              }
            }
            if (!estava) {
              examesAux[indexAux].status = 1
            }
          })

          exameInicial.forEach(function (elementInicial, indexInicial) {
            let removeu = false
            let idExame = 0
            for (let index = 0; index < examesAux.length; index++) {
              const element = examesAux[index]
              if (element.idExame == elementInicial.idExame) {
                removeu = true
                // idServico = element.idServico
              }
            }
            if (!removeu) {
              idExame = elementInicial.idExame
              examesAux.push({
                idExame: idExame,
                status: 0
              })
            }
          })

          examesAux.forEach(function (servico, index) {
            if (servico.status == 1) {
              let servicoAux = {
                idExame: servico.idExame,
                status: servico.status
              }
              examesAux.splice(index, 1)
              examesAux.unshift(servicoAux)
            }
            if (servico.status == 0) {
              let servicoAux = {
                idExame: servico.idExame,
                status: servico.status
              }
              examesAux.splice(index, 1)
              examesAux.push(servicoAux)
            }
          })

          // removendo o null
          for (let i = 0; i < examesAux.length; i++) {
            if (examesAux[i].status != null) {
              examesSemNull.push(examesAux[i])
              // console.log(diasDaSemanaAux);
            }
          }
          examesAux = examesSemNull
        }

        console.log('fim da picada', examesAux)
        // return;
        administradorUnidadeService.administradorUnidade
          .cadastrarExameMedico(this.idMedico, this.servicoSelecionado.idMedicoServico, examesAux)
          .then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data)

            if (rsp.data == 'erro') {
              this.erroEditar = true
            }

            if (rsp.data == true) {
              this.sucessoEditar = true
              setTimeout(() => this.voltar(), 2000)
              setTimeout(() => this.sucessoEditar = false, 2000)
              // this.clear();
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    cadastrarMedicoServico () {
      console.log('em cadastrar MedicoServico')

      if (this.$refs.form2.validate()) {
        let servicosAux = []
        let servicosSemNull = []
        this.erroServicosIguais = false
        // nesse caso quer dizer que removeu todos servicos
        if (this.exameInicial.length > 0 && this.servicosEscolhidos.length == 0) {
          console.log('primeiro if')
          for (let index = 0; index < this.exameInicial.length; index++) {
            const element = this.exameInicial[index]
            servicosAux[index] = {
              idServico: element.idServico,
              status: 0
            }
          }
          // console.log(servicosAux);
          // return
        }
        // nesse caso o medico inicialmente não tinha serviços e adicionou servicos ao medico
        else if (this.exameInicial.length == 0 && this.servicosEscolhidos.length > 0) {
          console.log('segundo if')
          for (let index = 0; index < this.servicosEscolhidos.length; index++) {
            const element = this.servicosEscolhidos[index]
            servicosAux[index] = {
              idServico: element,
              status: 1
            }
          }
          // console.log(servicosAux);
          // return
        }
        /// aqui
        else {
          let exameInicial = this.exameInicial
          // modifica o array
          for (let index = 0; index < this.servicosEscolhidos.length; index++) {
            const element = this.servicosEscolhidos[index]
            servicosAux[index] = {
              idServico: element,
              status: null
            }
          }

          servicosAux.forEach(function (elementEscolhido, indexAux) {
            let estava = false
            let index = 0
            for (let index = 0; index < exameInicial.length; index++) {
              const element = exameInicial[index]
              if (element.idServico == elementEscolhido.idServico) {
                estava = true
              }
            }
            if (!estava) {
              servicosAux[indexAux].status = 1
            }
          })

          // console.log(servicosAux);
          // return;
          exameInicial.forEach(function (elementInicial, indexInicial) {
            let removeu = false
            let idServico = 0
            for (let index = 0; index < servicosAux.length; index++) {
              const element = servicosAux[index]
              if (element.idServico == elementInicial.idServico) {
                removeu = true
                // idServico = element.idServico
              }
            }
            if (!removeu) {
              idServico = elementInicial.idServico
              servicosAux.push({
                idServico: idServico,
                status: 0
              })
            }
          })

          servicosAux.forEach(function (servico, index) {
            if (servico.status == 1) {
              let servicoAux = {
                idServico: servico.idServico,
                status: servico.status
              }
              servicosAux.splice(index, 1)
              servicosAux.unshift(servicoAux)
            }
            if (servico.status == 0) {
              let servicoAux = {
                idServico: servico.idServico,
                status: servico.status
              }
              servicosAux.splice(index, 1)
              servicosAux.push(servicoAux)
            }
          })

          // removendo o null
          for (let i = 0; i < servicosAux.length; i++) {
            if (servicosAux[i].status != null) {
              servicosSemNull.push(servicosAux[i])
              // console.log(diasDaSemanaAux);
            }
          }
          servicosAux = servicosSemNull
          console.log(servicosAux)
        }
        if (servicosAux.length == 0) {
          this.erroServicosIguais = true
        }

        administradorUnidadeService.administradorUnidade
          .cadastrarMedicoServico(this.idMedico, servicosAux).then(rsp => {
            console.log('rsp oi:')
            console.log(rsp.data.msg)
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }

            if (rsp.data == true) {
              this.sucessoEditar = true
              setTimeout(() => this.$router.push({
                path: '/listaMedicosUnidade'
              }), 2000)
              // this.clear();
            }
            // console.log(this.listaChamadas);
            // this.servicoTeste = rsp.data
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },
    clear () {
      this.$refs.form.reset()
    }

  }
}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31B0D5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: -4px;
  right: 10px;
}
</style>
